export const UPDATE_TAX_INPUT = "UPDATE_TAX_INPUT";
export const REQUEST_TAX_CALC = "REQUEST_TAX_CALC";
export const RECEIVE_TAX_CALC = "RECEIVE_TAX_CALC";
export const TAX_MORTGAGE_CALC_SHOW = "TAX_MORTGAGE_CALC_SHOW";
export const TAX_MORTGAGE_CALC_HIDE = "TAX_MORTGAGE_CALC_HIDE";
export const TAX_MORTGAGE_CALC_SAVE = "TAX_MORTGAGE_CALC_SAVE";
export const TAX_NEXT_WIZARD_STEP = "TAX_NEXT_WIZARD_STEP";
export const TAX_FROM_PROPERTY = "TAX_FROM_PROPERTY";




// WEBPACK FOOTER //
// ./src/Features/TaxCalculator/TaxActionTypes.jsx